import { useCallback, useEffect, useState } from 'react';
import { CurrencyInputOnChangeValues } from 'react-currency-input-field';
import { useSelector } from 'react-redux';
import { MeasurementSystem } from 'spw-components/unit-conversion/types';
import { selectMeasurementSystem } from 'spw-redux/modules/user/selectors';

export const useAvgFormLogic = ({ max }: { max: number }) => {
  const measurementSystem = useSelector(selectMeasurementSystem);
  const [value, setValue] = useState('');
  const [floatValue, setFloatValue] = useState(0);

  useEffect(() => {
    if (measurementSystem === MeasurementSystem.imperial) {
      setValue('');
      setFloatValue(0);
    }
  }, [measurementSystem]);

  const handleValueChanged = useCallback(
    (v?: string, name?: string, values?: CurrencyInputOnChangeValues) => {
      setValue(v);
      setFloatValue(values.float);
      if (values.float > max) {
        setValue(max.toString());
        setFloatValue(max);
      }
    },
    [max]
  );

  return {
    value,
    floatValue,
    handleValueChanged,
  };
};
